import { useDataSubmit, useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let onActionSetPatientOption = useDataOnActionSetPatient(props, data)

  return async function onSubmit({ args }) {
    switch (args.type) {
      case 'setPatient':
        return onActionSetPatientOption({ args })
      default:
        return
    }
  }
}

/** @type {import('Simple/types.js').useDataOnSubmit} */
function useDataOnActionSetPatient(props) {
  let submit = useDataSubmit({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })
  let patient_id = useDataValue({
    context: 'appointment_overlay',
    path: 'patient_id',
    viewPath: props.viewPath,
  })

  return async function onAction({ args }) {
    if (patient_id === args.patient_id) return

    if (typeof props.closePopover === 'function') props.closePopover()
    return submit({
      type: 'setPatient',
      patient_id: args.patient_id,
    })
  }
}
